import { CONSTANTS } from './constants';


export const getCustomerSite = (
  siteId: number,
  siteListDetails: any[],
  appLanguage: string
) => {
  if (siteListDetails?.length && siteId) {
    const site = siteListDetails.find((s: any) => s.id === siteId);
    const siteName =
      (appLanguage === CONSTANTS.DEFAULT_LANGUAGE
        ? site?.nameHE
        : site?.nameEN) ?? '';
    return `${siteId} - ${siteName}`;
  }
  return siteId;
};

export const getCustomerCity = (
  siteId: number,
  siteListDetails: any[],
  cities: any[],
  appLanguage: string
) => {
  if (siteListDetails?.length && siteId) {
    const site = siteListDetails.find((s: any) => s.id === siteId);
    if (site?.cityId && cities?.length) {
      const city = cities.find((c: any) => c.id === site.cityId);
      return (
        (appLanguage === CONSTANTS.DEFAULT_LANGUAGE
          ? city?.nameHE
          : city?.nameEN) ?? ''
      );
    }
  }
  return '';
};

export const getCityById = (
  cityId: number,
  cities: any[],
  appLanguage: string
) => {
  if (cities?.length && cityId) {
    const city = cities.find((c: any) => c.id === cityId);
    return (
      (appLanguage === CONSTANTS.DEFAULT_LANGUAGE
        ? city?.nameHE
        : city?.nameEN) ?? ''
    );
  }
  return '';
};